import { render } from "./MenuInfo.vue?vue&type=template&id=41890d93&scoped=true"
import script from "./MenuInfo.vue?vue&type=script&lang=js"
export * from "./MenuInfo.vue?vue&type=script&lang=js"

import "./MenuInfo.vue?vue&type=style&index=0&id=41890d93&scoped=true&lang=css"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41890d93"]])

export default __exports__